import { useParams } from 'react-router-dom'
import SalesTrackersReps from './Reps'

/**
 * /sales-trackers/reps/:ident — a deep link to one rep.
 *
 * A thin wrapper rather than a second implementation. The By Rep page took over
 * rendering a rep's sheet when it gained a dropdown, and keeping two copies of that
 * page would guarantee they drifted.
 *
 * The route is kept rather than removed because things point at it: Overview's rep
 * table builds links to it (Overview.tsx), and the accessibility spec navigates to it.
 * Preserving it costs these few lines.
 */
export default function SalesTrackersRepDetail() {
  const { ident } = useParams<{ ident: string }>()
  return <SalesTrackersReps initialIdent={ident} />
}
